export default "__VITE_ASSET__CtCeYfhJ__"